import { BaseContext } from "src/com/sixdee/crbtportal/utils/basecontext";
import { UIComponentHandler, UIDataModel } from "../../../../toolkit/uicomponent";
import { UIComponentViewImpl } from "../../../../toolkit/uicomponentview";
import * as React from "react";
import { LoaderWrapperComponent } from "../../../popup/loaderwrappercomponent";
import { LoaderComponent } from "../../../../toolkit/loader/loadercomponent";
import { DefaultFlashCardCSSStyle } from "./defaultflashcardcss";
import { DefaultFlashCardComponentHandler, DefaultFlashCardComponentProps, DefaultFlashCardComponentState } from "./defaultflashcardcomponent";
import { Strings } from "src/com/sixdee/crbtportal/utils/resources/strings";
import './defaultflashcard-style.css';
export class DefaultFlashCardViewImpl extends UIComponentViewImpl<UIDataModel> 
{  
    private loaderWrapperComponent:LoaderWrapperComponent;

    constructor(context: BaseContext, handler: UIComponentHandler)
    {
        super(context, handler);
    }

    bindHandlers()
    {
       this.onCreateClick = this.onCreateClick.bind(this);
    }

    draw(props: DefaultFlashCardComponentProps, state: DefaultFlashCardComponentState, cssStyle: DefaultFlashCardCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);
        return (
            <>
              <div id="default-card-wrapper">
                                {
                                    this.getWebView(props, state, cssStyle)
                                }
            </div>
            <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
            </>
        );
    }


    getWebView(props: DefaultFlashCardComponentProps, state: DefaultFlashCardComponentState, cssStyle: DefaultFlashCardCSSStyle)
    {
        return (
           <>
            <div id="default-card-main-wrapper"  style={cssStyle.getToneWrapperCSSStyle()} >
                 <div id="default-create-img" onClick={this.onCreateClick} style={{}}>
                        <img id="default-create-img-button"  src={this.getContext().getResources().getImage("add_blue.svg")} />
                 </div>
                 <label style={{width:"100%",height:"44px",marginTop:"23px", fontWeight:500, fontSize:"14px",lineHeight:"21px",color:"#FFFFFF"}}>
                    {this.getContext().getResources().getString(Strings.create_flash_message)}
                </label>   

            </div>    
           </>     
        );
    }
    showLoader()
    {       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }

    protected onCreateClick()
    {
        (this.getUIComponentHandler() as DefaultFlashCardComponentHandler).onCreateClick();
    }   

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/flashmessage/defaultflashcard/defaultflashcardview.tsx